module.exports = __webpack_public_path__ + "static/img/report_top.67e8451a.svg";